<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <TypeForm :formProps="formProps">
                </TypeForm>
            </template>
            <template #search="searchProps">
                <TypeSearch :searchProps="searchProps">
                </TypeSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import TypeForm from './TypeForm.vue'
import TypeSearch from './TypeSearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { __ } from '@pages/Helper/utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
